import React, { ReactNode, FunctionComponent } from 'react';
import { P3, TextColor, TextAlign, TextWeight } from 'components/typography';
import classNames from 'classnames';

export enum HintColor {
    BLACK,
    WHITE,
    GRAY_DARK,
}

const mapHintColorToTextColor = {
    [HintColor.BLACK]: TextColor.BLACK,
    [HintColor.WHITE]: TextColor.WHITE,
    [HintColor.GRAY_DARK]: TextColor.GRAY_DARK,
};

const mapHintColorToClassName = {
    [HintColor.BLACK]: 'hint--color-white',
    [HintColor.WHITE]: 'hint--color-white',
    [HintColor.GRAY_DARK]: 'hint--color-gray-dark',
};

export enum HintAlign {
    CENTER,
    INHERITED,
}

const mapHintAlignToTextAlign = {
    [HintAlign.CENTER]: TextAlign.CENTER,
    [HintAlign.INHERITED]: TextAlign.INHERITED,
};

type HintProps = {
    color?: HintColor;
    align?: HintAlign;
    isBold?: boolean;
    children: ReactNode;
};

const Hint: FunctionComponent<HintProps> = (props) => {
    const { color = HintColor.GRAY_DARK, align, isBold = false, children } = props;
    let textWeight: TextWeight | undefined;

    if (isBold) {
        textWeight = TextWeight.MEDIUM;
    }

    const className = classNames(
        'hint',
        typeof color !== 'undefined' && mapHintColorToClassName[color]
    );

    return (
        <div className={className}>
            <P3
                color={typeof color !== 'undefined' ? mapHintColorToTextColor[color] : undefined}
                align={typeof align !== 'undefined' ? mapHintAlignToTextAlign[align] : undefined}
                weight={textWeight}
            >
                {children}
            </P3>
        </div>
    );
};

export default Hint;
